import { useQuery } from "@tanstack/react-query";
import { apiClient } from "src/dm/utils/axios";

/**
 * Marketing messages including the bitmask-derived requires* flags. Distinct
 * from the plain `useMarketingMessages` (in `useLookups.ts`) — that hook
 * shapes rows as `{ code, description, ... }` for dropdowns, while this hook
 * shapes them as `{ id, description, requires* }` for the EditReward
 * validation flow (legacy `SetMarketingMessageFields` 0/1/2/3 bitmask).
 *
 * Backend: GET /api/dealmanagement/lookups/marketing-messages-with-flags
 *
 * Cached 5 minutes (server also caches).
 */
export interface MarketingMessageFlagsRow {
  id: string;
  description: string;
  requiresProductDescription: boolean;
  requiresTagQuantity: boolean;
}

interface Envelope {
  items: MarketingMessageFlagsRow[];
}

export const useMarketingMessagesWithFlags = () =>
  useQuery({
    queryKey: ["lookup-marketing-messages-with-flags"],
    queryFn: async (): Promise<MarketingMessageFlagsRow[]> => {
      const response = await apiClient.get<Envelope>(
        "/dm/V1/lookups/marketing-messages-with-flags"
      );
      return response.data.items ?? [];
    },
    staleTime: 5 * 60 * 1000,
  });
